import 'core-js/stable';
import 'regenerator-runtime/runtime'
import '@webcomponents/webcomponentsjs';
import 'resize-observer-polyfill';
import 'intersection-observer';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'isomorphic-fetch';
import 'abortcontroller-polyfill';
